import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * /saint-youtube-ad was a paid SAINT landing page with a hero + eligibility
 * form. It shared the exact same title/H1 as the indexable local page
 * /saint-therapy-coral-springs-fl ("SAINT® TMS in Coral Springs, FL"),
 * which Magnus Medical's provider locator links to. Consolidate onto that
 * page with a 301 redirect so the two URLs no longer compete in Google.
 */
export const Route = createFileRoute("/saint-youtube-ad")({
  beforeLoad: () => {
    // /saint-therapy-coral-springs-fl now 301s to /saint, so point the ad
    // slug straight at the consolidated SAINT page to avoid a chained hop.
    throw redirect({ to: "/saint", replace: true });
  },
});
